module.exports = __webpack_public_path__ + "media/images/v3/b_4-d4a5f7053129da9e96ccc6dd6f729e32.png";